import { useCallback, useState } from 'react'
import { UserType } from 'types/user'

type LinkUsers = {
  linkedUsers: UserType[]
  addLinkedUser: (user: UserType) => void
}

const useLinkUsers = (): LinkUsers => {
  const [linkedUsers, setLinkedUsers] = useState<UserType[]>([])
  const addLinkedUser = useCallback(
    (user: UserType) => {
      setLinkedUsers((prevState) => [...prevState, user])
    },
    [setLinkedUsers]
  )
  return { linkedUsers, addLinkedUser }
}

export default useLinkUsers
